import { FC, useState } from "react";

import { BestPracticeSvgLogo, Stack, Text } from "@bps/fluent-ui";
import { Form } from "@bps/form-api";

import { InactivityPinFormValues } from "./VerifyPinForm.interface";
import { VerifyPinFormFields } from "./VerifyPinFormFields";

export type VerifyPinFormProps = {
  submitPin: (pin: string) => Promise<void>;
};

// This component is a simplified version of the component from Bps.Platform.BpId.WebApp

export const VerifyPinForm: FC<VerifyPinFormProps> = ({ submitPin }) => {
  const [error, setError] = useState();

  return (
    <Stack horizontalAlign="center" verticalAlign="center" verticalFill grow>
      <Stack tokens={{ childrenGap: 24 }} styles={{ root: { maxWidth: 375 } }}>
        <Stack tokens={{ childrenGap: 8 }}>
          <BestPracticeSvgLogo isBlue width={375} />
          <Text variant="xLarge" styles={{ root: { textAlign: "center" } }}>
            Verify your identity
          </Text>
          <Text styles={{ root: { textAlign: "center" } }}>
            Enter your date of birth to confirm your identity and ensure this
            message is intended for you
          </Text>
        </Stack>
        <Form.Provider<InactivityPinFormValues>
          onSubmit={({ a, b, c, d, e, f }) => {
            setError(undefined);
            return submitPin([a, b, c, d, e, f].join("")).catch(error => {
              setError(error);
            });
          }}
        >
          {() => <VerifyPinFormFields isError={!!error} />}
        </Form.Provider>
      </Stack>
    </Stack>
  );
};
